module.exports = __webpack_public_path__ + "static/img/90097D_1_2_C_20220310_LC.a45f1b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/90097D_1_2_C_20220310_LC.png
// module id = z1y4
// module chunks = 0